export default __webpack_public_path__ + "static/media/naver.e2761d55.png";